export const getParentFromPath = (path?: string) => {
  if (!path) {
    return undefined
  }

  return path?.split('/')[path?.split('/').length - 1]?.split('-')?.join(' ')
}
